import { defaultERTableExpanded } from "@/components/widgets/tradeActionSummary/ActionSummaryTableHelperFunctions";
import { IHeaderParams } from "ag-grid-community";
import { useState } from "react";

/**
 * ExpandCollapseAllERHeader
 *
 * Custom header component for the expand column in ER (ExecutionRequest/Counterparty) level grids.
 * Provides expand all / collapse all functionality for OP trades with executionCounterparties.
 * Used in RFQ and other non-Order trades to allow OP to collapse/expand all counterparty rows.
 */
const ExpandCollapseAllERHeader = (props: IHeaderParams) => {
  // Default to expanded state based on the future-settings variable
  const [allExpanded, setAllExpanded] = useState(defaultERTableExpanded);

  const handleToggleAll = () => {
    if (props.api) {
      if (allExpanded) {
        // Collapse all
        props.api.forEachNode((node) => {
          if (node.master) {
            props.api.setRowNodeExpanded(node, false);
          }
        });
      } else {
        // Expand all
        props.api.forEachNode((node) => {
          if (node.master) {
            props.api.setRowNodeExpanded(node, true);
          }
        });
      }
      setAllExpanded(!allExpanded);
    }
  };

  return (
    <div
      data-testid="ExpandCollapseAllERHeaderContainer"
      id="ExpandCollapseAllERHeaderContainer"
      className="flex h-full w-full cursor-pointer items-center justify-center"
      onClick={handleToggleAll}
      title={
        allExpanded
          ? "Collapse all counterparties"
          : "Expand all counterparties"
      }
    >
      <span
        className={`ag-icon pl-1 ${allExpanded ? "ag-icon-tree-open" : "ag-icon-tree-closed"}`}
      />
    </div>
  );
};

export default ExpandCollapseAllERHeader;
